export default function Container({ children, className = "", as: As = "div", ...props }) {
  return (
    <As
      className={`max-w-[1280px] mx-auto w-full px-4 sm:px-6 lg:px-10 ${className}`}
      {...props}
    >
      {children}
    </As>
  );
}
